export const useListItemPresenter = ({ id, title, description, subTitle, checked, onClick }) => {
  const presenter = {
    itemClickHandler() {
      if (onClick) {
        onClick({ id, title, description, subTitle }, !checked);
      }
    },
  };

  return presenter;
};
